<script>
    // Ящик в руках: аккуратная панель справа по центру — картинка ящика,
    // товар и сколько единиц внутри. Язык тот же, что у экранов бизнесов.
    import '../../../business/menu/fonts/SFPro/stylesheet.css';

    let crate = null;
    window.bizCrateHud = (json) => {
        try { crate = json ? (typeof json === 'string' ? JSON.parse(json) : json) : null; }
        catch (e) { crate = null; }
    };
</script>

{#if crate}
<div class="bc">
    <div class="bc__box">
        <svg viewBox="0 0 48 40" class="bc__ico">
            <path d="M4 12l20-8 20 8-20 8-20-8z" fill="#E7AE3F" opacity=".9"/>
            <path d="M4 12v18l20 8V20L4 12z" fill="#C8852F" opacity=".85"/>
            <path d="M44 12v18l-20 8V20l20-8z" fill="#F0C863" opacity=".75"/>
            <path d="M14 8l20 8v6l-20-8V8z" fill="#221903" opacity=".25"/>
        </svg>
    </div>
    <div class="bc__name">{crate.p}</div>
    <div class="bc__count">{crate.u} <em>шт</em></div>
</div>
{/if}

<style>
    .bc {
        position: fixed; right: 2.4vh; top: 50%; transform: translateY(-50%);
        z-index: 45; width: 13vh; padding: 1.6vh 1.2vh 1.4vh;
        display: flex; flex-direction: column; align-items: center; gap: .5vh;
        background: rgba(20, 20, 22, .88); border-radius: 1.4vh;
        font-family: 'SF Pro Display', sans-serif; color: #F2F0EB;
        pointer-events: none;
    }
    .bc__box { width: 7vh; height: 6vh; display: flex; align-items: center; justify-content: center; }
    .bc__ico { width: 100%; height: 100%; }
    .bc__name {
        font-size: 1.3vh; font-weight: 600; text-align: center; line-height: 1.2;
        max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    }
    .bc__count { font-size: 1.9vh; font-weight: 600; color: #E7AE3F; }
    .bc__count em { font-style: normal; font-size: 1.1vh; font-weight: 500; color: rgba(242, 240, 235, .45); }
</style>
